import React, { FC } from 'react'
import { createHeaderBackgroundImage, HEADER_COLLAPSED_HEIGHT } from 'shared/utils/header'
import { useScroll } from 'shared/hooks'
import { IHeroImageProps } from './hero-image.props'

export const HeroImage: FC<IHeroImageProps> = ({ activeArtist }) => {
  const [refProxy] = useScroll<HTMLDivElement>(
    (ref, d) => ref.style.setProperty('--scroll-property', `${100 - d * 0.077}%`),
    HEADER_COLLAPSED_HEIGHT
  )

  return (
    <div
      ref={refProxy}
      className="header-img"
      style={createHeaderBackgroundImage(!!activeArtist, activeArtist?.image_url_data?.headerUrl || '')}
    />
  )
}
